<template>
    <section id="success-campaign">
        <b-modal 
            centered 
            @hide="hide" 
            id="campaign-success-modal" 
            ref="successCampRef" 
            hide-header 
            hide-footer>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="success-campaign mx-auto" :style="`height: ${modalHeight}`" v-if="user">
                            <div class="modal-holder position-relative">
                                <button
                                    @click="hide"
                                    aria-label="Close"
                                    id="modal-close"
                                    class="close pr-2">
                                        <CloseCross/>
                                </button>
                                <div class="success-campaign-form mx-auto">
                                    <div class="banner-header text-center">
                                        <Icon icon="badge-checkmark"/>
                                        <h5 class="heading eina-bold mt-4 mb-1">CONGRATULATIONS!</h5>
                                        <p class="mt-0">Your campaign is now verified!</p>
                                    </div>
                                    <div 
                                        v-if="!inPremium"
                                        class="banner-footer text-center d-flex flex-column align-items-center justify-content-center">
                                        <div>
                                            <p class="c16 p2n" style="line-hieght: 24px">
                                                You're on the <b>Basic plan.</b> <br>
                                                Go <b>Premium</b> and unlock full CrossProm <br>
                                                automations till the end of your campaign.
                                            </p>
                                            <Button 
                                                @click.native = "toPricing"
                                                type="button-green"
                                                class="p2n eina-semibold"
                                                style="line-height: 24px; width: 195px;height: 48px"
                                            >
                                                CHECK OFFER
                                            </Button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import { CloseCross } from '../components/Icons'
import Icon from '../components/Theme/Icon.vue'
import Button from '../components/Theme/Button.vue'
import {mapGetters, mapState} from 'vuex'

export default {
    name: 'CampSuccess',
    components: {
        Icon,
        Button,
        CloseCross
    },
    computed: {
        ...mapGetters(['inPremium']),
        ...mapState(['user']),
        modalHeight(){
            return !this.inPremium ? '442px' : '250px'
        }
    },
    mounted: function() {
        this.$bvModal.show(`campaign-success-modal`)
    },
    methods: {
        toPricing(){
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['camp-success', false])
            }, 0)
            this.$router.push('/pricing').catch(() => {})
        },
        hide: function(evt) {
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['camp-success', false])
            }, 0)
            this.$router.push('/').catch(() => {})
        },
    }
}

</script>

<style>
    @media screen and (min-width: 576px) {
            #campaign-success-modal .modal-dialog{
            max-width: 100%;
        }
    }
</style>

<style scoped lang="scss">

    div.success-campaign {
        width: 720px;
        @media screen and (max-width: 992px) {
            width: 80%;
        }

        .banner-header {
            height: 50%;
            padding-top: 56px;

            h5 {
                color: #000000;
            }

            p {
                color: #000000;
            }
        }

        .banner-footer {
            height: 50%;
            background: url(/img/campaign-verification-banner-background.png)
        }

        .heading {
            font-size: 28px;
            line-height: 32px;
        }

        .modal-holder {
            width: 100%;
            height: 100%;
            background: #FFFFFF;
            -webkit-box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
            box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);

            div.success-campaign-form {
                height: 100%;

                div.forgot-text {
                    p{
                        line-height: 160%;
                        color: #00000061;

                        &:first-child {
                            color: #858585;
                        }
                    }
                }
                div.form-div {
                    button.forgot {
                        height: 48px;
                        color: #ffffff;
                        background: #727CF5;
                        border-radius: 5px;
                        border: 0;
                        transition: all 0.1s linear;

                        &:hover {
                            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
                        }
                    }
                }
            }
        }
    }

    .md-field:first-child {
        margin-top: 59px;
    }

    .md-input {
        height: 48px !important;
        border: 1px solid #C7C4C4 !important;
        box-sizing: border-box;
        border-radius: 5px;
        padding-left: 10px !important;
    }

    .md-field label {
        position: absolute;
        top: 50%;
        left: 11px;
        pointer-events: none;
        transform: translateY(-35%);
        transition: .4s cubic-bezier(.25, .8, .25, 1);
        transition-duration: .3s;
        font-size: 13px;
        line-height: 20px;
        margin: 0;
    }

    .md-field.md-focused label, .md-field.md-has-value label {
        pointer-events: auto;
        top: 5px;
        opacity: 1;
        font-size: 12px;
        background: #fff;
    }

    .md-field {
        width: 100%;
        min-height: 48px;
        margin: 0px 0 22px;
        padding-top: 8px;
        display: flex;
        position: relative;
        font-family: inherit;
    }

    .md-field.md-theme-default::after, .md-field.md-theme-default:before {
        background-color: transparent;
        content: none !important;
    }

    .md-checkbox .md-checkbox-container {
        background: #B8CDD7;
        border: 1px solid #8DA0A9;
        box-shadow: inset 0px 10px 40px rgba(0, 0, 0, 0.05);
    }

    .md-checkbox .md-checkbox-label {
        height: 20px;
        padding-left: 7px;
        position: relative;
        line-height: 20px;
    }

    .md-checkbox {
        width: auto;
        margin: 0px 0px 20px 0;
        float: left;
    }

    .md-checkbox .md-checkbox-container input {
        position: absolute;
        left: 0 !important;
        right: 0 !important;
        top: 0 !important;
        bottom: 0 !important;
        margin: auto !important;
    }

    .forgotPass {
        float: right;
    }


    @media only screen and (min-width: 280px) and (max-width: 450px) {
        div.success-campaign,
        .modal-holder {
            width: 100%;
        }

        div.success-campaign-form {
            width: 280px;
        }

        .md-checkbox[data-v-60214417] {
            transform: translate(-10%);
        }
    }

</style>
